import React from 'react'

export const Loading = () => {
    return (
        <div className="preloader" id="preloader">
            <div className="preloader-inner">
                <div className="spinner">
                    <div className="dot1"></div>
                    <div className="dot2"></div>
                </div>
            </div>
        </div>
    )
}
